(ns minorodata.transform-environments.events
  (:require [minorodata.app.handlers :refer [reg-event-fx reg-event-db]]
            [minorodata.app.posthog-events :as posthog-events]
            [minorodata.app.utils :as app.utils]
            [minorodata.utils :as utils]
            [clojure.set]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]))

(defn valid-env-id [id]
  (and id
       (not= id app.utils/production-env-id)))

(reg-event-fx
 :environments.events/select-env
 (fn [_ [environment-id {:keys [source]}]]
   (let [valid? (valid-env-id environment-id)

         {:groups-panel/keys [active-group]}
         @(re-frame/subscribe [:groups-panel/pull '[{:groups-panel/active-group [:group/id]}]])

         group-id (:group/id active-group)

         switched? (if valid?
                     (not= environment-id @(re-posh/subscribe [:environments.subs/active-environment-id]))
                     (not @(re-posh/subscribe [:environments.subs/production-active?])))]

     (cond->
      {:set-local-storage ["environments-panel-active-id" environment-id]
       :dispatch-n
       (cond-> [[:environments-panel/update {:environments-panel/active-id environment-id}]
                [:groups-panel/delete]
                [:groups-panel/add]
                [:app.events/navigate :transformations]]
         valid?       (concat [[:environments.api/fetch-environment {:environment-id environment-id}]])
         (not valid?) (concat [[:group.api/fetch-groups {:replace? true}]]))
       :dispatch-later
       (cond-> []
         group-id (concat [{:ms       1
                            :dispatch [:environments.api/fetch-transforms {:group-id group-id}]}]))}

       (and source switched?)
       (assoc :posthog/capture {:event (:transform-environment/selected posthog-events/events)
                                :props {:environment-id environment-id
                                        :source         source}})))))

(reg-event-fx
 :environments.events/toggle-merge-transform-id
 (fn [_ [transform-id]]
   (let [ids     @(re-posh/subscribe [:environments-panel/prop :environments-panel/merge-transform-ids])
         already-selected? (some #(= transform-id %) ids)
         new-ids (if already-selected?
                   (remove #(= transform-id %) ids)
                   (conj ids transform-id))]
     {:dispatch [:environments-panel/update {:environments-panel/merge-transform-ids new-ids}]})))

(reg-event-fx
 :environments.events/validate-environment
 (fn [_ [environments]]
   (let [prod-env?    @(re-posh/subscribe [:environments.subs/production-active?])
         active-id    @(re-posh/subscribe [:environments.subs/active-environment-id])]
     (when (and (not prod-env?)
                (seq environments)
                (not (utils/find-by-field environments :environment/environment-id active-id)))
       {:dispatch-n [[:environments.events/select-env app.utils/production-env-id]
                     [:app.events/add-snack :warning "Selected environment not found. Moving to production environment"]]}))))

(reg-event-db
 :environments.events/add-all-input-table
 (fn [db [table]]
   (let [currently-selected (get db :input-tables/all #{})]
     (assoc db :input-tables/all (conj currently-selected table)))))

(reg-event-db
 :environments.events/add-all-input-tables
 (fn [db [tables]]
   (let [currently-selected (get db :input-tables/all #{})]
     (assoc db :input-tables/all (set (concat currently-selected tables))))))

(reg-event-db
 :environments.events/add-initial-input-table
 (fn [db [table]]
   (let [currently-selected (get db :input-tables/initial #{})]
     (assoc db :input-tables/initial (conj currently-selected table)))))

(reg-event-db
 :environments.events/add-table-to-copy
 (fn [db [table]]
   (let [currently-selected (get db :db-copy/tables #{})
         updated (if (set? table)
                   (clojure.set/union currently-selected table)
                   (conj currently-selected table))]
     (assoc db :db-copy/tables updated))))

(reg-event-db
 :environments.events/remove-table-to-copy
 (fn [db [table]]
   (let [currently-selected (get db :db-copy/tables #{})
         updated (if (set? table)
                   (clojure.set/difference currently-selected table)
                   (disj currently-selected table))]
     (assoc db :db-copy/tables updated))))

(reg-event-db
 :environments.events/clear-table-to-copy
 (fn [db [table]]
   (assoc db :db-copy/tables #{})))
